import React from "react";

export default {
  InfoIcon: (
    <svg focusable="false" width="24px" height="24px" aria-hidden="true" viewBox="0 0 24 24">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"></path>
    </svg>
  ),
  ListIcon: (
    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-njtpvy" focusable="false" aria-hidden="true"
         viewBox="0 0 24 24" data-testid="DescriptionIcon">
      <path
        d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm2 16H8v-2h8zm0-4H8v-2h8zm-3-5V3.5L18.5 9z"></path>
    </svg>
  ),
  CartFilledIcon: (
    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-njtpvy" focusable="false" aria-hidden="true"
         viewBox="0 0 24 24" data-testid="ShoppingCartIcon">
      <path
        d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2M1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2"></path>
    </svg>
  ),
  PaymentIcon: (
    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium  css-1k2di3w" focusable="false" aria-hidden="true"
         viewBox="0 0 24 24" data-testid="PaymentsIcon" aria-label="fontSize medium">
      <path
        d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2m-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m13-6v11c0 1.1-.9 2-2 2H4v-2h17V7z"></path>
    </svg>
  ),
  DownloadIcon: (
    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium  css-1k2di3w" focusable="false" aria-hidden="true"
         viewBox="0 0 24 24" data-testid="DownloadingIcon" aria-label="fontSize medium">
      <path
        d="M18.32 4.26C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9m-1.62 5.9 1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89M13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62M13 12V7h-2v5H7l5 5 5-5zm-2 7.93v2.02c-5.05-.5-9-4.76-9-9.95s3.95-9.45 9-9.95v2.02C7.05 4.56 4 7.92 4 12s3.05 7.44 7 7.93"></path>
    </svg>
  ),
  UploadIcon: (
    <svg fill="currentColor" className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium  css-1k2di3w" focusable="false" aria-hidden="true"
         viewBox="0 -960 960 960" data-testid="DownloadingIcon" aria-label="fontSize medium">
      <path
        d="M441-82q-76-8-141.5-41.5t-114.5-87Q136-264 108-333T80-480q0-157 104.5-270T441-878v81q-119 15-200 104.5T160-480q0 123 81 212.5T441-163v81Zm0-198v-247L337-423l-56-57 200-200 200 200-57 56-103-103v247h-80Zm80 198v-81q44-5 83.5-22t72.5-43l57 58q-45 36-99 59T521-82Zm155-650q-33-26-72-43t-83-22v-81q60 6 114 29t99 59l-58 58Zm114 505-57-57q26-33 43-72.5t22-83.5h81q-6 60-29.5 114T790-227Zm8-293q-5-44-22-83.5T733-676l57-57q36 45 59.5 99T879-520h-81Z"/>
    </svg>
  ),
  SettingsIcon: (
    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1wmkh38" focusable="false" aria-hidden="true"
         viewBox="0 0 24 24" data-testid="SettingsIcon">
      <path
        d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"></path>
    </svg>
  ),
  ChevronRight: (
    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1wmkh38" focusable="false" aria-hidden="true"
         viewBox="0 0 24 24" data-testid="ChevronRightIcon">
      <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
    </svg>
  ),
  UnfoldMore: (
    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1thwf1" focusable="false" aria-hidden="true" fill="currentColor"
         viewBox="0 0 24 24" aria-label="fontSize medium">
      <path
        d="M12 5.83 15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15z"></path>
    </svg>
  ),
  AspectRatio: (
    <svg width="24px" height="24px" fill="currentColor" viewBox="0 0 1280.000000 1280.000000"
         preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
         stroke="none">
      <path d="M1390 11185 c-405 -87 -718 -383 -828 -784 l-27 -96 0 -3905 0 -3905 27 -97 c55 -198 151 -360 296 -500 159 -152 326 -240 537 -283 73 -14 534 -15 5040 -13 l4960 3 80 23 c95 28 241 95 322 149 84 55 223 192 283 279 68 98 125 222 158 342 l27 97 0 3905 0 3905 -27 97 c-33 120 -90 244 -158 342 -60 87 -199 224 -283 279 -81 54 -227 121 -322 149 l-80 23 -4970 2 c-4216 1 -4980 -1 -5035 -12z m9810 -4785 l0 -3730 -4800 0 -4800 0 0 3730 0 3730 4800 0 4800 0 0 -3730z"/>
        <path d="M7460 8535 l0 -535 800 0 800 0 0 -800 0 -800 540 0 540 0 0 1335 0 1335 -1340 0 -1340 0 0 -535z"/>
        <path d="M2660 5065 l0 -1335 1340 0 1340 0 0 535 0 535 -800 0 -800 0 0 800 0 800 -540 0 -540 0 0 -1335z"/>
      </g>
    </svg>
  ),
  CopyIcon: (
    <svg className="transition" fill="currentColor" focusable="false" aria-hidden="true" viewBox="0 0 24 24" aria-label="fontSize small">
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"></path>
    </svg>
  ),
  PasteIcon: (
    <svg fill="currentColor" focusable="false" aria-hidden="true" viewBox="0 0 24 24" aria-label="fontSize small">
      <path d="M5 5h2v3h10V5h2v6h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1"></path>
      <path d="m18.01 13-1.42 1.41 1.58 1.58H12v2h6.17l-1.58 1.59 1.42 1.41 3.99-4z"></path>
    </svg>
  ),
}
